import React from "react";
import { Link } from "react-router-dom";

function PageNotFound({url}) {
  return (
    <div className="ds-container">
      <div className="grid --narrow _paddingTop--epic">
        <div className="ds-card _marginTop--epic">
          <div className="cardSection _textAlign_center">
            <h1 className="-primary" style={{ 'font-size': '8em' }}> 404 </h1>
            <div className="subhead"> Page not available </div>
            <div className="copy"> It seems that you're lost. No worries! We'll help you get back on track. </div>
          </div>

          <Link to={url || `/`} className="ds-btn --medium --full">
            Go Back
          </Link>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/PageNotFound.js